import http from "@/utils/http";

/**
 * 获取用户信息
 * @returns
 */
export const getUserInfoApi = () => {
  return http.get<UserInfo>("/api/auth/getUser");
};
export interface UserInfo {
  id: number;
  uid: string;
  icon: string;
  nickName: string;
  sex: number;
  status: number;
  language: string;
  phone: string;
  createTime: number;
  tuoAge: number;
  isFill: boolean;
  sourceBazaar: string;
  isOldMembers: number;
  energy: number;
  isMembers: number;
  configOpen: number;
  isedu: number;
  userLevel: number;
  nonMemberDomains: NonMemberDomain[];
  newMemberLevel: number;
  specialCode: number;
  newMemberEndTime: number;
  mobileToken: {
    expireIn: number;
    token: string;
  };
  //剩余次数AI
  vipTimes:number;
  //剩余次数AI免费
  freeTimes:number;
}

export interface NonMemberDomain {
  type: number;
  energy: number;
  uid: string;
}
